// React
import { memo } from "react";

// UI
import { TableSearch } from "ui/components/Table/TableSearch";

// Tipovi i konstante
import { OTHER_VALUE_COLUMNS } from "./consts";
import { OtherValuesCardProps } from "./types";

/** Minimum, godišnji popust, probni period i maksimalne količine po vozilu. */
const OtherValuesCard: React.FC<OtherValuesCardProps> = (props: OtherValuesCardProps) => {
  const { values } = props;

  return (
    <div className="p-6">
      <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
        <div className="flex flex-col flex-1 max-w-[300px]">
          <p className="text-base font-bold text-slate-600 py-3">Ostale vrijednosti</p>
          <p className="text-sm text-slate-500">
            Minimum, popust na godišnje plaćanje, probni period i maksimalne količine po vozilu.
          </p>
        </div>

        <div className="flex-1">
          <TableSearch
            columns={OTHER_VALUE_COLUMNS}
            data={values}
            selectableRows={false}
            disablePagination
          />
        </div>
      </div>
    </div>
  );
};

export default memo(OtherValuesCard);
